import React from "react";
// import '../Menu2.css'; // New CSS file
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const PlatformFeatures = () => {
	return (
		<>
			<Navbar />
			<div>
				<Homecarousel />
			</div>

			<div style={{ padding: "5px", maxWidth: "1330px", margin: "0 auto" }}>
				<div className="content-container" style={{ marginBottom: "3rem" }}>
					<div style={{ marginBottom: "0rem", marginTop: "40px" }}>
						<h2
							style={{
								fontFamily: "Rajdhani, sans-serif",
								fontSize: "30px",
								fontWeight: "600",
								letterSpacing: "0.5px",
								lineHeight: "30px",
							}}>
							Powering Your Path to Global Standards
						</h2>
					</div>
					<div className="text-container-2" style={{ width: "100%" }}>
						<p>
							At the Global Academy for Food Safety and Sustainability
							Standards, we bring together technology, expertise, and innovation
							to make compliance easy, profitable, and transformative. Here’s
							how our platform helps you lead the way:
						</p>
						<ul
							style={{
								margin: "0px",
								padding: "0px",
								display: "flex",
								flexDirection: "column",
								gap: "10px",
							}}>
							<li style={{ margin: "0px" }}>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="koul-text">
										<b>Learn on Your Terms</b>
										<br />
										Self-paced and expert-led courses designed to fit your
										schedule and your goals — making learning flexible,
										relevant, and engaging.
									</span>
								</div>
							</li>
							<li style={{ margin: "0px" }}>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="koul-text">
										<b>See Standards in Action</b>
										<br />
										Our Model Farms showcase real-world best practices, so you
										can see what success looks like and replicate it in your own
										operations.
									</span>
								</div>
							</li>
							<li style={{ margin: "0px" }}>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="koul-text">
										<b>TraceAudit™ — Your Digital Compliance Partner</b>
										<br />
										Streamlines standards compliances, boosts transparency, and
										builds buyer & certifiers trust before the audit even
										begins.
									</span>
								</div>
							</li>
							<li style={{ margin: "0px" }}>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="koul-text">
										<b>Extensive Course Library</b>
										<br />
										From on-farm production to post-harvest, sustainability, and
										export standards — we’ve got every stage of your value chain
										covered.
									</span>
								</div>
							</li>
							<li style={{ margin: "0px" }}>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="koul-text">
										<b>Certification Readiness Made Easy</b>
										<br />
										Step-by-step guides, checklists, and templates so you can
										prepare with confidence and ace every audit.
									</span>
								</div>
							</li>
						</ul>
						<br />
						Meanwhile, standard owners and certifiers can’t offer direct
						implementation help — leaving a huge gap. That’s where we come in.
						The Global Academy bridges this gap with independent, expert-led,
						and tech-enabled support — so you’re not just certified, you’re
						market-ready, profitable, and future-proof.
					</div>
				</div>
				<div className="content-container" style={{ marginBottom: "3rem" }}>
					<div style={{ marginBottom: "0rem", marginTop: "20px" }}>
						<h2
							style={{
								fontFamily: "Rajdhani, sans-serif",
								fontSize: "30px",
								fontWeight: "600",
								letterSpacing: "0.5px",
								lineHeight: "30px",
							}}>
							The Bottom Line:
						</h2>
					</div>
					<div className="text-container" style={{ width: "100%" }}>
						<span>
							Our platform doesn’t just teach — it transforms. We make complex
							standards simple, build market trust, and unlock premium
							opportunities — so you’re always a step ahead in the global food
							supply chain.
						</span>
					</div>
				</div>
				<div className="content-container">
					<div style={{ marginBottom: "0rem", marginTop: "20px" }}>
						<h2
							style={{
								fontFamily: "Rajdhani, sans-serif",
								fontSize: "30px",
								fontWeight: "600",
								letterSpacing: "0.5px",
								lineHeight: "30px",
							}}>
							Ready to level up your business?
						</h2>
					</div>
					<div className="text-container-2" style={{ width: "100%" }}>
						<span>Start your journey with us today.</span>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default PlatformFeatures;
